import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

function FontRadar() {
  // Navs and Footer
  useEffect(() => {
    const nav = document.querySelector(".navigation-large");
    nav.className =
      "navigation-large d-none d-md-flex justify-content-between fixed-top section-bg";
  }, []);

  useEffect(() => {
    const nav = document.querySelector(".navigation-small");
    nav.className =
      "navigation-small d-flex justify-content-between d-md-none fixed-top section-bg";
  }, []);

  useEffect(() => {
    const footer = document.querySelector(".footer-contain");
    footer.className = "footer-contain section-bg";
  }, []);

  return (
    <>
      <Container className="section-contain">
        <Helmet>
          <body className="section-bg" />
          <title>Font Radar - GarageFonts</title>
          <meta property="og:title" content="Font Radar - GarageFonts" />
        </Helmet>
        <Row>
          <Col md={12}>
            <h1 className="header">Font Radar</h1>
          </Col>
        </Row>
        <Row>
          <Col lg={7} className="mt-4">
            <p>
              We work with{" "}
              <a
                href="https://www.fontradar.com/"
                target="_blank"
                rel="noreferrer"
              >
                Font Radar
              </a>{" "}
              to help us verify the validity of font licenses.
            </p>
            <p>
              Any email received from GarageFonts@licenses.fontradar.com, is
              sent on our behalf. Please <Link to="/contact">contact us</Link>{" "}
              for further information.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default FontRadar;
